export default __webpack_public_path__ + "static/image1-ff026abc2d1840375b438a799b9817ab.png";